import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosPostV3 } from '../../api/axios-handler';

const trustedSignupRequest = async (token: string, packageCode: string) => {
  const payload = {
    keycloak_token: token,
    package_code: packageCode,
  };

  const response = await axiosPostV3(`/members/trusted`, payload);
  console.log('response', response);
  return response;
};

export const useTrustedSignup = () => {
  const queryClient = useQueryClient();
  const trustedSignup = useMutation(
    ({ token, packageCode }: { token: string; packageCode: string }) => {
      return trustedSignupRequest(token, packageCode);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['me']);
      },
      retry: false, // Disable retries since this is a one-time operation
      onError: (error) => {
        console.error('Trusted signup failed:', error);
      },
    },
  );

  return {
    trustedSignup,
  };
};
